import React from 'react';
import { createTableElementClassName } from './tableStyles';

type Props = {
  text: React.ReactNode;
  disableNoBreakHack?: boolean;
};

export const TableTd = (props: Props) => {
  const { text, disableNoBreakHack } = props;

  const className = createTableElementClassName('cell', { td: true });

  return (
    <td className={className}>
      {disableNoBreakHack ? text : <div className="nobr">{text}</div>}
    </td>
  );
};
